// Where the login page may send an OTP. An OTP exchanges for the user's JWT, so it only goes to the company apps:
// the same origins the identity backend allows through CORS.
const allowedOrigin = /^(https?:\/\/localhost(:\d+)?|https:\/\/([a-z0-9-]+\.)+(devsoft\.vn|songtek\.net|gooddev\.app))$/;

export function isAllowedOrigin (origin: string | null | undefined): origin is string {
    return !!origin && allowedOrigin.test(origin);
}

// /Goto/:url takes the target as base64 (callers use btoa). Returns null when it is not a company app URL.
export function gotoTarget (encoded: string): URL | null {
    try {
        const url = new URL(atob(encoded));
        return isAllowedOrigin(url.origin) ? url : null;
    } catch {
        return null;
    }
}

// /auth?redirectToPath=/Goto/... : a path on this site only, never another site.
export function redirectPath (value: string | null | undefined): string {
    return value && value.startsWith('/') && !value.startsWith('//') && !value.startsWith('/\\') ? value : '/';
}

// The origin of the page framing us (/RefreshToken posts the OTP there). location.ancestorOrigins is Chromium/Safari;
// Firefox falls back to the referrer, which is the framing page under the default referrer policy.
export function topOrigin (location: Location, referrer: string): string | null {
    const ancestors = location.ancestorOrigins;
    if (ancestors && ancestors.length) {
        return ancestors[ancestors.length - 1];
    }
    try {
        return referrer ? new URL(referrer).origin : null;
    } catch {
        return null;
    }
}
